import { csCZ, deDE, enUS, frFR, nlNL, roRO, skSK, svSE } from "@mui/material/locale";
import {
	csCZ as csCZ_dataGrid,
	deDE as deDE_dataGrid,
	enUS as enUS_dataGrid,
	frFR as frFR_dataGrid,
	nlNL as nlNL_dataGrid,
	roRO as roRO_dataGrid,
	skSK as skSK_dataGrid,
	svSE as svSE_dataGrid,
} from "@mui/x-data-grid/locales";
import {
	csCZ as csCZ_datePickers,
	deDE as deDE_datePickers,
	enUS as enUS_datePickers,
	frFR as frFR_datePickers,
	nlNL as nlNL_datePickers,
	roRO as roRO_datePickers,
	skSK as skSK_datePickers,
	svSE as svSE_datePickers,
} from "@mui/x-date-pickers/locales";
import { cs, de, enUS as enUS_dateFns, frCH, nl, ro, sk, sv } from "date-fns/locale";
import { getTheme } from "../core/theme";
import { importMediaPaths } from "../core/useMedia";
import _config from "./config.js";
// services
import i18n from "../../services/i18n";
// types
import type { Locale } from "date-fns/locale";
import type { Config } from "../../types/config";
import type { Language } from "../../types/misc";

export { default as FLAGS } from "./flags";
export { default as icons } from "../core/icons";
export { useMedia } from "../core/useMedia";

export const config = _config as Config;

importMediaPaths(
	require.context("./media", true, /\.(?:jpe?g|png|webp|avif|gif|svg|mp4)$/), // filter not possible to extract into a constant
	require.context("../core/media", true, /\.(?:jpe?g|png|webp|avif|gif|svg|mp4)$/) // filter not possible to extract into a constant
);

const language = i18n.resolvedLanguage as Language;

const l10nDateFns = {
	cs: cs,
	de: de,
	en: enUS_dateFns,
	fr: frCH,
	nl: nl,
	ro: ro,
	sk: sk,
	sv: sv,
} as const satisfies Record<string, Locale>;
export const localeDateFns = l10nDateFns[language] as Locale;

const l10nMuiTheme = {
	cs: csCZ,
	de: deDE,
	en: enUS,
	fr: frFR,
	nl: nlNL,
	ro: roRO,
	sk: skSK,
	sv: svSE,
} as const;

const l10nDataGrid = {
	cs: csCZ_dataGrid,
	de: deDE_dataGrid,
	en: enUS_dataGrid,
	fr: frFR_dataGrid,
	nl: nlNL_dataGrid,
	ro: roRO_dataGrid,
	sk: skSK_dataGrid,
	sv: svSE_dataGrid,
} as const;

const l10nDatePickers = {
	cs: csCZ_datePickers,
	de: deDE_datePickers,
	en: enUS_datePickers,
	fr: frFR_datePickers,
	nl: nlNL_datePickers,
	ro: roRO_datePickers,
	sk: skSK_datePickers,
	sv: svSE_datePickers,
} as const;

export const muiTheme = getTheme("#008fff", l10nMuiTheme[language], l10nDataGrid[language], l10nDatePickers[language]);
